import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ShowVendorServices, DeleteServices } from "../../../../context/Slice/ServiceManagementSlice";
import { FaImage, FaRegFileAlt } from 'react-icons/fa';
import secureLocalStorage from 'react-secure-storage';
import {jwtDecode} from 'jwt-decode';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Services.css';
import Swal from 'sweetalert2';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import AddService from './AddService';
import EditService from './EditService';

const Services = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const VendorServices = useSelector((state) => state.ServiceManagementR.Data);
    const [show, setShow] = useState(false);
    const [selectedServices, setSelectedServices] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isAdding, setIsAdding] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [ID, setID] = useState("");

    const token = secureLocalStorage.getItem('token');

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                const ID = decoded._id;
                setID(ID)
                dispatch(ShowVendorServices(ID));
            } catch (error) {
                console.error("Token decoding failed:", error);
            }
        }
    }, [dispatch, token]);

    const handleClose = () => setShow(false);
    const handleShow = (services) => {
        setSelectedServices(services);
        setShow(true);
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Delete this service",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                popup: 'swal2-popup'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(DeleteServices(id))
                    .then(() => {
                        dispatch(ShowVendorServices(ID)); // Refresh the service list
                        Swal.fire(
                            'Deleted!',
                            'The service has been deleted.',
                            'success'
                        );
                    })
                    .catch((error) => {
                        console.error("Error deleting service:", error);
                        Swal.fire(
                            'Error!',
                            'There was an error deleting the service.',
                            'error'
                        );
                    });
            }
        });
    };

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
        });
    }, []);

    const filteredServices = VendorServices.filter((service) =>
        service.ServiceName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        service.City.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const renderImages = (images) => {
        const parsedImages = JSON.parse(images || '[]');
        return parsedImages.map((img, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
                <div className="card">
                    <div className="card-img">
                        <img src={`${BASE_URL}/uploads/${img.filename}`} alt="" className="img-fluid" />
                    </div>
                </div>
            </div>
        ));
    };

    const renderBannerImage = (bannerImages) => {
        const parsedBannerImages = JSON.parse(bannerImages || '[]');
        if (parsedBannerImages.length > 0) {
            return (
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={`${BASE_URL}/BannerUploads/${parsedBannerImages[0].filename}`} alt="Banner Image" className="d-block w-100" />
                    </div>
                </div>
            );
        }
        return null;
    };

    const handleFormClose = () => {
        setIsAdding(false);
        setIsEditing(false);
    };

    const handleEdit = (service) => {
        setSelectedServices(service);
        setIsEditing(true);
    };

    const refreshServiceList = () => {
        dispatch(ShowVendorServices(ID));
    };

    const renderVideo = (video) => {
        let videoData = null;
        try {
            videoData = JSON.parse(video || null);
        } catch (error) {
            console.error("Error parsing video JSON:", error);
        }
        if (videoData) {
            const videoSrc = `${BASE_URL}/VideoUploads/${videoData.filename}`;
            return (
                <div className="ratio ratio-16x9">
                    <video controls src={videoSrc}></video>
                </div>
            );
        }
        return null;
    };

    return (
        <>
            {!isAdding && !isEditing && (
                <div id="Vendor-service">
                    <div>
                        <h2 className="heading">Services</h2>
                        <div className="searchField row">
                            <input
                                type="text"
                                placeholder="Search "
                                className="searchInput"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Box display="flex" justifyContent="center" mt="10px" mb="10px">
                                <Button type="submit" variant="contained" className="primary fs-4" onClick={() => {
                                    setIsAdding(true);
                                }}>
                                    Create New Service
                                </Button>
                            </Box>
                        </div>
                    </div>
                    <div className='grid'>
                        {VendorServices && VendorServices.length > 0 ? (
                            VendorServices.map((services, index) => (
                                <div className="card" key={index}>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold">{services.ServiceName}</h5>
                                        <p className="card-text"><strong>City:</strong> {services.City} </p>
                                        <p className="card-text"><strong>Address:</strong> {services.Address} </p>
                                        <p className="card-text"><strong>Rating:</strong> {services.Rating} </p>
                                        <renderVideo/>
                                        <div className="button-container">
                                            <button className="btn" onClick={() => handleShow(services)}>View</button>
                                            <button className="btn" onClick={() => handleDelete(services.id)}>Delete</button>
                                            <button className="btn" onClick={() => handleEdit(services)}>Edit</button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No events available.</p>
                        )}
                    </div>

                    {show && selectedServices && (
                        <div className="custom-modal">
                            <div className="custom-modal-content">
                                <div className="custom-modal-header">
                                    <h5 className="custom-modal-title">{selectedServices.ServiceName}</h5>
                                    <button type="button" className="close" onClick={handleClose}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="custom-modal-body">
                                    <div>
                                        <div className="carousel slide mt-3" data-ride="carousel" data-aos="fade-up">
                                            {renderBannerImage(selectedServices.BannerImage)}
                                        </div>
                                    </div>
                                    <p><strong>Description:</strong> {selectedServices.ServiceDescription}</p>
                                    <p><strong>Start Price Range:</strong> {selectedServices.StartpriceRange}</p>
                                    <p><strong>End Price Range:</strong> {selectedServices.EndpriceRange}</p>
                                    <p className="card-text"><strong>City:</strong> {selectedServices.City} </p>
                                    <p className="card-text"><strong>Address:</strong> {selectedServices.Address} </p>
                                    <p className="card-text"><strong>Rating:</strong> {selectedServices.Rating} </p>
                                    <div className="content-section" id="gallery" data-aos="fade-left">
                                        <h3><FaImage /> Gallery</h3>
                                        <div className="container">
                                            <div className="row gy-4">
                                                {renderImages(selectedServices.image)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-section" id="video" data-aos="fade-left">
                                        <h3><FaRegFileAlt /> Video</h3>
                                        {renderVideo(selectedServices.Video)}
                                    </div>
                                </div>
                                <div className="custom-modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            {isAdding && <AddService handleFormClose={handleFormClose} refreshServiceList={refreshServiceList} />}
            {isEditing && <EditService handleFormClose={handleFormClose} refreshServiceList={refreshServiceList} selectedService={selectedServices} />}
        </>
    );
};

export default Services;
